/**
 * Workshop Participants - Show/Hide fields based on cart quantity
 */
(function() {
  function showParticipantFields() {
    const quantity = window.tilmaCartQuantity || 1;

    // Hide all fields first by marking them
    document.querySelectorAll('[class*="wc-block-components-address-form__tilma-participant_"]').forEach(field => {
      field.setAttribute('data-participant-hidden', 'true');
    });

    // Show only needed fields, add headings and wrap in grid container
    for (let i = 0; i < quantity; i++) {
      const nameField = document.querySelector(`.wc-block-components-address-form__tilma-participant_${i}_name`);
      const emailField = document.querySelector(`.wc-block-components-address-form__tilma-participant_${i}_email`);
      const phoneField = document.querySelector(`.wc-block-components-address-form__tilma-participant_${i}_phone`);
      const positionField = document.querySelector(`.wc-block-components-address-form__tilma-participant_${i}_position`);

      if (nameField && emailField && phoneField && positionField) {
        // Remove hidden attribute
        nameField.removeAttribute('data-participant-hidden');
        emailField.removeAttribute('data-participant-hidden');
        phoneField.removeAttribute('data-participant-hidden');
        positionField.removeAttribute('data-participant-hidden');

        // Check if already wrapped
        if (!nameField.parentElement.classList.contains('participant-fields-wrapper')) {
          // Create heading
          const heading = document.createElement('h3');
          heading.className = 'participant-heading';
            heading.textContent = quantity > 1 ? `Účastník kurzu ${i + 1}` : 'Účastník kurzu';

          // Create wrapper
          const wrapper = document.createElement('div');
          wrapper.className = 'participant-fields-wrapper';

          // Insert heading before name field
          nameField.parentNode.insertBefore(heading, nameField);

          // Insert wrapper before name field
          nameField.parentNode.insertBefore(wrapper, nameField);

          // Move all 4 fields into wrapper
          wrapper.appendChild(nameField);
          wrapper.appendChild(emailField);
          wrapper.appendChild(phoneField);
          wrapper.appendChild(positionField);
        }
      }
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showParticipantFields);
  } else {
    showParticipantFields();
  }

  // Also run after a short delay (for React rendering)
  setTimeout(showParticipantFields, 500);
  setTimeout(showParticipantFields, 1000);
  setTimeout(showParticipantFields, 2000);
})();
